//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BrigadeCardCheckbox from './BrigadeCardCheckbox.vue'

export default {
  name: 'BrigadeCardCheckboxWithForever',
  components: {
    BrigadeCardCheckbox
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    forever: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueLocal: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
        this.foreverLocal = false
      }
    },
    foreverLocal: {
      get: function () {
        return this.forever
      },
      set: function (value) {
        this.$emit('update:forever', value)
      }
    }
  }
}
